const typeResolvers = {};

const resolvers = {};

const getNotifications = pageInput => {
  return [
    {
      id: '1',
      retailer: {
        Id: '153',
      },
      title: 'Phoebe Buffay',
      body: 'They dont know that we know they know we know',
      expiryDate: '30-10-2019',
      status: 'READ',
      notificationId: '1',
      notificationDetailId: '1',
    },
    {
      id: '2',
      retailer: {
        Id: '153',
      },
      title: 'Chandler M Bing',
      body:
        'In Tulsa it is allowed to smoke in public areas having less than 15 people',
      expiryDate: '30-10-2019',
      status: 'UNREAD',
      notificationId: '2',
      notificationDetailId: '2',
    },
  ];
};

const mocks = {
  Query: {
    retailerNotifications: (_, { pageInput }) => getNotifications(pageInput),
  },
  Mutation: {},
};
export { resolvers, typeResolvers, mocks };
